import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import useEventMetadata from '../../hooks/useEventMetadata';
import { useEventsMerged } from '../../hooks/useEventsMerged';
import { EventKioskResultsComponent } from './EventKioskResultsComponent';

export const FB_IMG_PATH = 'img/event/banner/facebook-icon/';

const PureEventKioskResults = (props) => {
  const athlinksEventId = props.eventId
  const eventMetadata = useEventMetadata(athlinksEventId, {
    skip: !athlinksEventId
  })

  const { eventsMerged } = useEventsMerged(props.masterId, props.eventId)

  return <EventKioskResultsComponent
    {...props}
    event={eventsMerged}
    eventMetadata={eventMetadata}
  />
}

export const EventKioskResults = compose(
  withTranslation(),
  injectIntl,
)(PureEventKioskResults)
